var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4855 3.51436C12.9468 -4.00924 0.0123199 1.34871 0.00228966 11.9989C-0.130729 18.4481 5.55138 24.1312 12.0012 23.9975C22.6518 23.9869 28.0091 11.0522 20.4855 3.51436ZM12.0011 22.1228C6.41867 22.1228 1.87706 17.5812 1.87706 11.9988C2.43318 -1.43207 21.571 -1.42818 22.1251 11.9989C22.1251 17.5812 17.5835 22.1228 12.0011 22.1228ZM17.3304 7.79672C16.8217 7.70064 16.3315 8.03553 16.2356 8.5443C16.2356 8.5443 16.0933 9.22842 16.0831 9.27295C15.6698 10.9515 12.9382 10.6975 12.9385 8.91594V8.5773C12.889 7.33355 11.1128 7.33448 11.0637 8.5773C11.0637 8.5773 11.0549 8.87235 11.0549 8.91594C11.056 10.6864 8.35137 10.9519 7.91571 9.29564L7.76671 8.49874C7.67161 7.98987 7.182 7.65428 6.67299 7.74962C6.16412 7.84476 5.82867 8.33442 5.92386 8.84334L7.01932 14.7025C7.01964 14.7042 7.01993 14.7059 7.0203 14.7076C7.24636 15.8811 8.27873 16.7328 9.47505 16.7328H14.5272C15.7234 16.7328 16.7558 15.8811 16.9826 14.7038L18.0781 8.89152C18.1739 8.38274 17.8392 7.89257 17.3304 7.79672ZM14.5271 14.8579H9.475C9.17639 14.8579 8.91879 14.6465 8.86161 14.3548L8.44793 12.1422C9.67669 12.511 11.1734 12.1268 11.9967 11.2339C12.8225 12.1301 14.3275 12.5133 15.5582 12.1386L15.1409 14.3529C15.0846 14.6455 14.8264 14.8579 14.5271 14.8579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.2f740bb2.svg";
export { ForwardRef as ReactComponent };